import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { ThemeType } from '../styles/themes';

const ThemeSelector: React.FC = () => {
  const { currentTheme, setTheme, colors } = useTheme();

  const themes: { value: ThemeType; label: string; description: string; preview: string }[] = [
    {
      value: 'light',
      label: 'Light Theme',
      description: 'Clean and modern light theme with excellent readability',
      preview: 'linear-gradient(135deg, #F3F4F6 0%, #FFFFFF 100%)'
    },
    {
      value: 'dark',
      label: 'Dark Theme',
      description: 'Professional dark theme that reduces eye strain',
      preview: 'linear-gradient(135deg, #1a1f2e 0%, #242b3d 100%)'
    },
    {
      value: 'neon',
      label: 'Neon Theme',
      description: 'Ultra-modern cyberpunk theme with electric colors',
      preview: 'linear-gradient(135deg, #FF006E 0%, #00F5FF 50%, #BF00FF 100%)'
    },
    {
      value: 'vibrant',
      label: 'Vibrant Theme',
      description: 'Colorful and energetic theme with modern gradients',
      preview: 'linear-gradient(135deg, #8B5CF6 0%, #EC4899 100%)'
    },
    {
      value: 'sunrise',
      label: 'Sunrise Theme',
      description: 'Warm and inviting theme with coral and golden tones',
      preview: 'linear-gradient(135deg, #FF6B6B 0%, #FFD93D 100%)'
    },
    {
      value: 'ocean',
      label: 'Ocean Theme',
      description: 'Calming blues and teals inspired by the sea',
      preview: 'linear-gradient(135deg, #06B6D4 0%, #4ECDC4 100%)'
    },
    {
      value: 'forest',
      label: 'Forest Theme',
      description: 'Natural greens and earth tones for a refreshing feel',
      preview: 'linear-gradient(135deg, #10B981 0%, #84CC16 100%)'
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold" style={{ color: colors.text.primary }}>
        Choose Theme
      </h3>
      <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
        {themes.map((theme) => (
          <button
            key={theme.value}
            onClick={() => setTheme(theme.value)}
            className={`p-4 rounded-lg transition-all duration-200 ${
              currentTheme === theme.value
                ? `ring-2 ring-offset-2 ring-[${colors.primary.main}]`
                : 'hover:scale-105'
            }`}
            style={{
              backgroundColor: colors.background.paper,
              borderColor: colors.border.main,
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              color: colors.text.primary,
            }}
          >
            <div className="flex flex-col items-start space-y-2">
              <div className="w-full h-20 rounded-md mb-3" style={{
                background: theme.preview
              }} />
              <span className="font-medium">{theme.label}</span>
              <p className="text-sm" style={{ color: colors.text.secondary }}>
                {theme.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeSelector; 